export default __webpack_public_path__ + "static/media/bug.5d8e8fd5.svg";